<template>
    <div class="k-time-tracker">
        <div v-if="variant === 'chip'">
            <div class="border-selected">

                <v-list-item class="px-1">
                    <template v-slot:prepend>
                        <div class="border-selected">
                            <v-avatar :color="running ? 'red' : 'var(--primary)'" :size="24" @click="toggleTimer"
                                class="rounded-xl assignee-avatar d-flex ma-auto">
                                <span class="d-flex ma-auto" v-html="trackingicon"></span>
                            </v-avatar>
                        </div>
                    </template>
                    <v-list-item-title>{{
            formattedTime
        }}</v-list-item-title>

                </v-list-item>
            </div>
        </div>
        <div v-else-if="variant === 'card'">
            <h2>{{ title }}</h2>
            <p>{{ formattedTime }}</p>
            <button @click="toggleTimer">{{ running ? 'Stop' : 'Start' }} Tracking</button>
        </div>



    </div>
</template>

<script>
import api from '@/services/api';

export default {
    props: {
        variant: {
            type: String,
            default: 'chip',
        },
        title: {
            type: String,
            default: 'Time Tracker',
        },
        meta: {
            type: Object,
            default: () => ({
                ticket_id: null,
                task_id: null,

            }),
        },
    },
    data() {
        return {
            running: false,
            startTime: null,
            elapsedTime: 0,
            timerInterval: null,
        };
    },
    computed: {
        formattedTime() {
            const totalSeconds = Math.floor(this.elapsedTime / 1000);
            const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
            const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
            const seconds = String(totalSeconds % 60).padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`;
        },
        trackingicon() {


            const stop = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M340-340h280v-280H340v280Zm140.13 220q-74.67 0-140.41-28.34-65.73-28.34-114.36-76.92-48.63-48.58-76.99-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.34 65.73 28.34 114.36 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.13q0 74.67-28.34 140.41-28.34 65.73-76.92 114.36-48.58 48.63-114.26 76.99Q554.81-120 480.13-120Z"/></svg>';
            const start = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M400-336.92 623.08-480 400-623.08v286.16ZM480.13-120q-74.67 0-140.41-28.34-65.73-28.34-114.36-76.92-48.63-48.58-76.99-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.34 65.73 28.34 114.36 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.13q0 74.67-28.34 140.41-28.34 65.73-76.92 114.36-48.58 48.63-114.26 76.99Q554.81-120 480.13-120Z"/></svg>';
            return this.running ? stop : start;
        },
    },
    methods: {


        async checkActiveTimer() {
            try {
                const response = await api.get('/api/v1/time-tracking/active');
                if (response.data.active) {
                    this.startTime = response.data.start_time * 1000; // Epoch omzetten naar milliseconden
                    this.running = true;
                    this.syncElapsedTime();
                }
            } catch (error) {
                console.error('Error fetching active timer:', error);
            }
        },
        syncElapsedTime() {
            if (this.running) {
                this.timerInterval = setInterval(() => {
                    this.elapsedTime = (Date.now() - this.startTime);
                }, 1000);
            }
        },
        async toggleTimer() {
            if (this.running) {
                clearInterval(this.timerInterval);
                const endTime = Math.floor(Date.now() / 1000); // Epoch in seconden
                await api.post('/api/v1/time-tracking/stop', { end_time: endTime });

                this.running = false;
                this.elapsedTime = 0; // Reset timer UI
            } else {
                const response = await api.post('/api/v1/time-tracking/start', {
                    start_time: Math.floor(Date.now() / 1000),
                    task_id: this.meta.task_id ? this.meta.task_id : null,
                    ticket_id: this.meta.ticket_id ? this.meta.ticket_id : null,

                });
                this.startTime = response.data.start_time * 1000; // Epoch omzetten naar milliseconden
                this.elapsedTime = Date.now() - this.startTime; // Direct juiste tijd berekenen
                this.running = true;
                this.syncElapsedTime();
            }
        }
    },
    mounted() {
        this.checkActiveTimer();
    }
};
</script>
